import {createAsyncThunk} from "@reduxjs/toolkit";
import request from "../../../../service";
import {
    deleteDegree, deletedRestoreDegree, setDegreeRestoreData,
    setEducationalDegree,
    updateDegree,
} from "./educationDegreeSlice";


import {IErrorResponse, IRootState} from "../../../../types";
import {IEducationalDegreeCreate, IEducationalDegreePayload} from "../types";

const CreateEducationDegree = createAsyncThunk(
    "create/degree",
    async (payload: IEducationalDegreeCreate, {rejectWithValue}) => {
        try {
            const response = await request.post("/educational-degrees", payload);
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const GetEducationalDegree = createAsyncThunk(
    "get/educational/degree",
    async (_, {dispatch, rejectWithValue, getState}) => {
        try {
            const response = await request.get("/educational-degrees");
            const lang = getState() as IRootState

            const defaultLanguage = lang.languages.defaultLanguage
            dispatch(setEducationalDegree({data: response.data, defaultLanguage}));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);

const EditEducationDegree = createAsyncThunk<
    IEducationalDegreePayload,
    { formattedValues: IEducationalDegreePayload }
>("edit/educational/degree", async ({formattedValues}, thunkAPI) => {
    try {
        const response = await request.put(
            `/educational-degrees/${formattedValues.id}`,
            {
                status: formattedValues.status,
                start_date: formattedValues.start_date,
                end_date: formattedValues.end_date,
                translations: formattedValues.translations,
            }
        );

        thunkAPI.dispatch(updateDegree({updatedDegree: response.data}));

        return response.data as IEducationalDegreePayload;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return thunkAPI.rejectWithValue(typedError.response.data.message || "unexpected_fail");

    }
});

const DeleteEducationDegree = createAsyncThunk(
    "delete/educational/degree",
    async (id :number, thunkAPI) => {
        try {
            const response = await request.delete(`/educational-degrees/${id}`);

            thunkAPI.dispatch(deleteDegree(id));


            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;

            return thunkAPI.rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);


const GetDeleteDegree = createAsyncThunk(
    "get/delete/degree",
    async (_, {dispatch, rejectWithValue}) => {
        try {
            const response = await request.get(`/educational-degrees/deleted-items`);

            dispatch(setDegreeRestoreData(response.data));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);

const RestoreDeleteDegree = createAsyncThunk(
    "restore/degree",
    async (id:number, {dispatch, rejectWithValue}) => {
        try {
            const response = await request.post(`/educational-degrees/restore/${id}`);

            dispatch(deletedRestoreDegree(id));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);


export {
    GetEducationalDegree,
    EditEducationDegree,
    CreateEducationDegree,
    DeleteEducationDegree,
    GetDeleteDegree,
    RestoreDeleteDegree
};
